import React, { memo } from 'react';
import { MechanicalContractor } from './types';
import MechanicalContractorDetailsHeader from './MechanicalContractorDetailsHeader';
import MechanicalContractorBasicDetails from './MechanicalContractorBasicDetails';
import MechanicalContractorSubOffices from './MechanicalContractorSubOffices';

interface MechanicalContractorDetailsCardProps {
  contractor: MechanicalContractor;
  onEdit: () => void;
  canEdit: boolean;
}

const MechanicalContractorDetailsCard = memo(({
  contractor,
  onEdit,
  canEdit
}: MechanicalContractorDetailsCardProps) => {
  // Get the head office address for display
  const headOfficeAddress = contractor.address?.find(addr => addr.addressType === 'head-office');
  const addressString = headOfficeAddress ?
    [headOfficeAddress.address, headOfficeAddress.city, headOfficeAddress.province?.name, headOfficeAddress.postalCode]
      .filter(Boolean)
      .join(', ') : '';

  return (
    <div className="bg-white rounded-lg border border-gray-200 mb-6">
      <MechanicalContractorDetailsHeader
        contractor={contractor}
        onEdit={onEdit}
        canEdit={canEdit}
      />

      {/* Information Grid */}
      <div className="p-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-12 gap-y-6">
          {/* Left Column */}
          <MechanicalContractorBasicDetails
            contractor={contractor}
            headOfficeAddress={addressString}
          />

          {/* Right Column */}
          <MechanicalContractorSubOffices contractor={contractor} />
        </div>
      </div>
    </div>
  );
});

MechanicalContractorDetailsCard.displayName = 'MechanicalContractorDetailsCard';

export default MechanicalContractorDetailsCard;